<template>
  <div class="splash">
    <div class="filter">
      <div class="section-header">
        <el-row><span>Dashboard</span></el-row>
      </div>
      <el-row class="filter-section">
        <label><span class="filter-title-label">Date Range</span>
        <el-date-picker
          class="filter-section-input"
          label="Date Range"
          v-model="filterDateRange"
          type="daterange"
          placeholder="Date Range"
          format="dd-MM-yyyy" range-separator=" ~ "
          :picker-options="pickerOptions"
          :clearable="false"
          small
          v-on:change="dateRangeUpdated">
          <template slot="prepend">Http://</template>
        </el-date-picker>
        </label>
        <label><span class="filter-title-label">Unit</span>
        <el-select v-model="selectedUnit" placeholder="Unit" class="filter-section-input" v-on:change="unitUpdated">
          <el-option
          label="All Units"
          :value='0'>
          </el-option>
          <el-option
          v-for="item in units"
          :label="item.displayText"
          :value="item.id">
            <span style="float: left">{{ item.displayText }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
        </label>
        <label>
        <span class="filter-title-label">Infection Site</span>
        <el-select v-model="filteredSite" class="filter-section-input" placeholder="Select Infection Site"
        v-on:change="symptomTypeUpdated">
          <el-option v-for="item in symptomTypes"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
        </label>
        <label>
        <span class="filter-title-label">Origin</span>
        <el-select v-model="selectedOrigin" class="filter-section-input" placeholder="Origin" v-on:change="originUpdated">
          <el-option
          v-for="item in origins"
          :label="item.label"
          :value="item.value">
          </el-option>
        </el-select>
        </label>
        <label>
        <span class="filter-title-label">Status</span>
        <el-select v-model="selectedStatus" class="filter-section-input" placeholder="Status" v-on:change="confirmStatusUpdated">
          <el-option
            label="All"
            :value='0'>
          </el-option>
          <el-option
            label="Confirmed"
            :value='1'>
          </el-option>
          <el-option
            label="Suspected"
            :value='2'>
          </el-option>
        </el-select>
        </label>
      </el-row>
    </div>
    <!--<div class="graph">
      <temp-chart :width=1500></temp-chart>
    </div>-->
    <div class="section-header">
      <el-row>
        Case Frequency
        <div class="graph-filter">
          <el-radio-group v-model="graphPeriodFilter" size="small">
            <el-radio-button label="By Year"></el-radio-button>
            <el-radio-button label="By Quarter"></el-radio-button>
            <el-radio-button label="By Month"></el-radio-button>
            <el-radio-button label="By Week"></el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="graphDisplayFilter" size="small">
            <el-radio-button label="By Unit"></el-radio-button>
            <el-radio-button label="By Infection Site"></el-radio-button>
          </el-radio-group>
        </div>
      </el-row>
    </div>
    <div class="graph">
      <inf-case-graph
        :range="filterDateRange"
        :period="filterPeriods" 
        :sites="filterSymptomTypes"
        :origin="filterOrigin"
        :confirmed="filterConfirmStatus"
        :config="graphConfig"
        :mode="graphMode"
        :unitId="selectedUnit">
      </inf-case-graph>
    </div>
    <div class="section-header">
      <el-row><span>Case Detail</span>
        <div class="case-filter">
          <el-button class="case-export-button" :plain="true" type="primary" size="mini" @click="exportExcel()">Export Data</el-button>
          <el-select
            class="case-page-size-filter"
            size="mini"
            v-model="symptomDetailPageSize"
            placeholder="Choose tags for your article">
            <el-option
              v-for="item in symptomDetailPageSizeOptions"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="symptomDetailPage"
            :page-count="symptomDetailPageTotal"
            v-on:current-change="reloadPage">
          </el-pagination>
        </div>
      </el-row>
    </div>
    <el-dialog title="Case Detail" v-if="selectedCase" v-model="dialogFormVisible">
      <!--<symptom-case-detail
       :caseData="selectedCase"
       :clientData="clients[selectedCase.clientId]"
       :origins="origins"
       :organisms="organisms"
       :treatments="treatments">
      </symptom-case-detail>-->
      <surveillance-case-detail
        :caseData="selectedCase"
        :clientData="clients[selectedCase.clientId]"
        :origins="origins"
        :organisms="organisms"
        :treatments="treatments">
      </surveillance-case-detail>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveSymtomDetail(selectedCase)">Update</el-button>
        <el-button type="primary" @click="dialogFormVisible = false; this.selectedCase = null">Close</el-button>
      </span>
    </el-dialog>
    <el-table
    :data="cases"
    style="width: 100%"
    v-on:row-click="selectedRow"
    v-loading.body="loadingData"
    :default-sort = "{prop: 'onSetDate', order: 'descending'}"
    >
      <el-table-column
        fixed
        label=" "
        width="100">
        <template scope="scope">
          <div style="padding: 0.5em;">
          <div :span="4" class="profile-row-photo" v-if="clients[scope.row.clientId]"><img :src="photosUrl(scope.row.clientId)"></div>
          <div :span="4" class="profile-row-photo" v-else><img src="~assets/user.png"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        sortable
        fixed
        width="180">
        <template scope="scope">
          <span v-if="clients[scope.row.clientId]">{{ clientName(scope.row) }}<br />({{clients[scope.row.clientId].patientId}})</span>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Infection Site"
        width="140">
        <template scope="scope">
          <span class="color-code-label-0" v-if="scope.row.symptomType === 'GI'"></span>
          <span class="color-code-label-2" v-else-if="scope.row.symptomType === 'UTI'"></span>
          <span class="color-code-label-1" v-else></span>
          {{ scope.row.symptomType }}
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        width="80">
        <template scope="scope">
          <img class="symptom-status-image" :src="statusImage(scope.row)">
        </template>
      </el-table-column>
      <el-table-column
        label="Symptoms"
        min-width="160">
        <template scope="scope">
          <el-tag v-for="d in scope.row.symptoms" :key="d.id" :type="tagType(d)">{{ d.displayText }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Precautions"
        min-width="160">
        <template scope="scope">
          <div v-if="clients[scope.row.clientId]">
            <el-tag v-for="d in clients[scope.row.clientId].precautionDetails">{{ precautionById(d.precautionId) }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <!--<el-table-column
        label="Resolution"
        width="220">
        <template scope="scope">
          {{ scope.row.resolved }}
        </template>
      </el-table-column>-->
      <el-table-column
        label="Location"
        width="160">
        <template scope="scope">
          {{ unitById(scope.row.unitId) }} / {{ beds[scope.row.bedId] }}
        </template>
      </el-table-column>
      <el-table-column
        label="Origin"
        width="200">
        <template scope="scope">
          {{ originById(scope.row.origin) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Organism"
        width="220">
        <template scope="scope">
          {{ organismById(scope.row.organismId) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Treatment"
        width="220">
        <template scope="scope">
          {{ treatmentById(scope.row.treatmentId) }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Onset Date"
        prop="onSetDate"
        sortable
        width="140">
        <template scope="scope">
          {{ scope.row.onSetDate | moment('DD-MM-YYYY') }}
        </template>
      </el-table-column>

    </el-table>  
  </div>
</template>

<script>
import InfCaseGraph from '../components/InfCaseGraph'
import SymptomCaseDetail from '../components/SymptomCaseDetail'
import SurveillanceCaseDetail from '../components/SurveillanceCaseDetail'
import auth from '../auth'

import moment from 'moment'

module.exports = {
  name: 'splash',
  components: {
    'inf-case-graph': InfCaseGraph,
    'symptom-case-detail': SymptomCaseDetail,
    'surveillance-case-detail': SurveillanceCaseDetail
  },
  data: function () {
    return {
      initialRun: true,
      loadingData: true,
      currentDate: new Date(),
      cases: [],
      precautions: [],
      beds: {},
      symptomTypes: [],
      searchNameInput: '',
      graphConfig: {},
      graphMode: 'site',
      clients: {},
      origins: [{
        value: 0,
        label: 'All'
      },
      {
        value: 'HAI',
        label: 'HAI'
      },
      {
        value: 'Community Acquired',
        label: 'Community Acquired'
      }],
      statusImageMap: {
        'GI': 'bug2',
        'UTI': 'bug3',
        'Respiratory': 'bug1'
      },
      selectedCase: null,
      selectedUnit: 0,
      selectedOrigin: 0,
      dialogFormVisible: false,
      selectedStatus: 0,
      symptomDetailPage: 1,
      symptomDetailPageSize: 10,
      symptomDetailPageTotal: 0,
      symptomDetailPageSizeOptions: [
        {
          label: '5 items per page',
          value: 5
        },
        {
          label: '10 items per page',
          value: 10
        },
        {
          label: '20 items per page',
          value: 20
        },
        {
          label: '50 items per page',
          value: 50
        }
      ],
      filterDateRange: '',
      filteredSite: {},
      filterPeriods: 'week',
      filterSymptomTypes: [],
      filterConfirmStatus: null,
      filterOrigin: null,
      organisms: [],
      treatments: [],
      units: [],
      graphPeriodFilter: 'By Week',
      graphDisplayFilter: 'By Infection Site',
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = moment().weekday(-1).hours(23).minutes(59).toDate()
            console.log(end)
            const start = moment().weekday(-7).toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last month',
          onClick (picker) {
            const lastMonth = moment().subtract(1, 'months')
            const end = lastMonth.endOf('month').toDate()
            const start = lastMonth.startOf('month').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last year',
          onClick (picker) {
            const lastYear = moment().subtract(1, 'years')
            const end = lastYear.endOf('year').toDate()
            const start = lastYear.startOf('year').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Current week',
          onClick (picker) {
            const end = moment().weekday(6).add(1, 'days').subtract(1, 'minutes').toDate()
            const start = moment().weekday(0).toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Current month',
          onClick (picker) {
            const lastMonth = moment()
            const end = lastMonth.endOf('month').toDate()
            const start = lastMonth.startOf('month').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Current year',
          onClick (picker) {
            const end = moment().endOf('year').toDate()
            const start = moment().startOf('year').toDate()
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    exportExcel: function () {
      console.log('exportExcel clicked')
      var unitId = this.selectedUnit
      var after = this.filterDateRange[0]
      var before = this.filterDateRange[1]
      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/export/excel/' + '?start=' + after + '&end=' + before
      rUrl = rUrl + '&types=' + this.filterSymptomTypes

      if (this.selectedOrigin !== 0) {
        rUrl = rUrl + '&origin=' + this.selectedOrigin
      }

      if (this.selectedStatus !== 0) {
        rUrl = rUrl + '&confirmed=' + (this.selectedStatus === 1 ? 'true' : 'false')
      }

      this.$http.get(rUrl).then(response => {
        console.log(JSON.stringify(response, ' ', 2))
        var headers = response.headers.map
        var blob = new window.Blob([response.data], { type: headers['content-type'] })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'report.xls'
        link.click()
      })
      // window.location.href = rUrl
    },
    loadCases: function () {
      var vm = this
      this.loadingData = true
      var unitId = this.selectedUnit
      var after = this.filterDateRange[0]
      var before = this.filterDateRange[1]

      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/page/' + (vm.symptomDetailPage - 1) + '?size=' + vm.symptomDetailPageSize + '&start=' + after + '&end=' + before
      rUrl = rUrl + '&types=' + this.filterSymptomTypes

      if (this.selectedOrigin !== 0) {
        rUrl = rUrl + '&origin=' + this.selectedOrigin
      }

      if (this.selectedStatus !== 0) {
        rUrl = rUrl + '&confirmed=' + (this.selectedStatus === 1 ? 'true' : 'false')
      }

      this.$http.get(rUrl)
      .then(response => {
        if (response.body && response.body['content'].length > 0) {
          var cases = response.body['content'] // response.body['_embedded'].symptomDetails
          var callbackCounter = 0

          vm.symptomDetailPageTotal = response.body['totalPages']
          cases.forEach(function (c) {
            if (c.origin == null) {
              c.origin = 0
            }
            c.symptoms.sort(function (a, b) {
              return a.colorCode > b.colorCode
            })
            vm.loadImage(c, function () {
              callbackCounter++
              if (callbackCounter >= cases.length) {
                vm.cases = cases
              }
            })
          })
        } else {
          console.log('no content')
          vm.cases = []
        }

        vm.loadingData = false
      }, response => {
        // error callback
      })

      if (this.initialRun) {
        this.initialRun = false
        vm.$watch('graphPeriodFilter', function (val) {
          if (vm.graphPeriodFilter === 'By Year') {
            vm.filterPeriods = 'year'
          } else if (vm.graphPeriodFilter === 'By Quarter') {
            vm.filterPeriods = 'quarter'
          } else if (vm.graphPeriodFilter === 'By Month') {
            vm.filterPeriods = 'month'
          } else if (vm.graphPeriodFilter === 'By Week') {
            vm.filterPeriods = 'week'
          }
        })

        vm.$watch('graphDisplayFilter', function (val) {
          console.log(val)
          if (vm.graphDisplayFilter === 'By Unit') {
            vm.graphMode = 'unit'
          } else {
            vm.graphMode = 'site'
          }
        })

        vm.$watch('symptomDetailPageSize', function (val) {
          vm.symptomDetailPage = 1
          vm.loadCases()
        })
      }
    },
    loadOrganisms: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/organisms/')
      .then(response => {
        vm.organisms = response.body['_embedded'].organisms
        vm.loadPrecautions()
      }, response => {
        // error callback
      })
    },
    loadPrecautions: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/precautions/')
      .then(response => {
        vm.precautions = response.body['_embedded'].precautions
        vm.loadTreatments()
      }, response => {
        // error callback
      })
    },
    loadTreatments: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/treatments/')
      .then(response => {
        vm.treatments = response.body['_embedded'].treatments
        vm.loadCases()
      }, response => {
        // error callback
      })
    },
    loadUnits: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/units', {
        headers: {
          'Authorization': 'Bearer ' + auth.getToken()
        }
      })
      .then(response => {
        vm.units = response.body['_embedded'].units
        vm.graphConfig = { units: vm.units }

        if (vm.selectedUnit === null && vm.units && vm.units.length > 0) {
          vm.selectedUnit = vm.units[0].value
        }

        vm.units.forEach(function (u) {
          vm.loadRooms(u)
        })

        vm.loadSymptomTypes()
      })
    },
    loadRooms: function (unit) {
      var vm = this
      this.$http.get(window.CONFIG.api + '/units/' + unit.id + '/rooms')
      .then(response => {
        // console.log(response)
        var rooms = response.body['_embedded'].rooms
        rooms.forEach(function (room) {
          var beds = room.beds
          beds.forEach(function (bed) {
            vm.beds[bed.id] = room.displayText + '-' + bed.displayText
            // console.log(unit.displayText + '/' + room.displayText + '-' + bed.displayText)
          })
        })
      }, response => {

      })
    },
    loadSymptomTypes: function () {
      var vm = this

      // http://localhost:8080/symptoms/classtypes
      this.symptomTypes = []
      this.$http.get(window.CONFIG.api + '/symptoms/classtypes')
      .then(response => {
        var newTypes = response.body
        if (newTypes && newTypes.length > 0) {
          vm.symptomTypes.push({'text': 'All Infection Site', 'value': 0})
          for (var i = 0; i < newTypes.length - 1; i++) {
            var s = {}
            s.text = newTypes[i]
            s.value = i + 1
            vm.symptomTypes.push(s)
          }
          vm.filteredSite = vm.symptomTypes[0].value
          console.log(vm.symptomTypes)
        }
        vm.loadOrganisms()
      })
    },
    nameFilter: function (cases) {
      var vm = this
      return cases.filter(function (detail) {
        return detail.name.toLowerCase().includes(vm.searchNameInput.toLowerCase())
      })
    },
    reloadPage: function (page) {
      if (this.symptomDetailPage !== page) {
        this.symptomDetailPage = page
        this.loadCases()
      }
    },
    loadImage: function (detail, callback) {
      var vm = this
      if (this.clients[detail.clientId] || this.clients[detail.clientId] === false) {
        callback()
        return
      }
      this.clients[detail.clientId] = false
      this.$http.get(window.CONFIG.api + '/clients/' + detail.clientId)
      .then(response => {
        vm.$set(vm.clients, detail.clientId, response.body)
        vm.$forceUpdate()
        callback()
      }, response => {
        // error
        callback()
      })
    },
    statusImage: function (detail) {
      if (detail.symptomType) {
        var filename = this.statusImageMap[detail.symptomType]
        if (!detail.confirmed) {
          filename = filename + 's'
        }
        return '/static/' + filename + '.png'
      }
    },
    tagType: function (type) {
      if (type.colorCode === '0') {
        return 'success'
      } else if (type.colorCode === '1') {
        return 'primary'
      } else if (type.colorCode === '2') {
        return 'warning'
      } else if (type.colorCode === '3') {
        return 'danger'
      }
      return 'gray'
    },
    selectedRow: function (row, event, column) {
      this.selectedCase = JSON.parse(JSON.stringify(row))
      if (!this.selectedCase.origin) {
        this.selectedCase.origin = 0
      }
      console.log(JSON.stringify(this.selectedCase, ' ', 2))
      console.log(JSON.stringify(this.clients[this.selectedCase.clientId], ' ', 2))
      this.dialogFormVisible = true
    },
    dateRangeUpdated: function (value) {
      // console.log(value)
      if (!value) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)

        this.filterDateRange = [start, end]
      } else {
        const start = moment(this.filterDateRange[0]).hours(0).minutes(0).seconds(0).toDate()
        const end = moment(this.filterDateRange[1]).hours(23).minutes(59).seconds(59).toDate()
        console.log(start)
        console.log(end)
        this.filterDateRange = [start, end]
      }

      this.loadCases()
    },
    unitUpdated: function (value) {
      console.log('unit : ' + value)
      this.loadCases()
    },
    symptomTypeUpdated: function (value) {
      var vm = this
      var sypmtomTypeFilter = []
      if (this.symptomTypes) {
        this.symptomTypes.forEach(function (s, i) {
          if ((vm.filteredSite === 0 || vm.filteredSite === s.value) && i !== 0) {
            sypmtomTypeFilter.push(s.text)
          }
        })
      }

      this.filterSymptomTypes = sypmtomTypeFilter
      this.loadCases()
    },
    originUpdated: function (value) {
      if (value === 0) {
        this.filterOrigin = null
      } else {
        this.filterOrigin = value
      }
      console.log('originUpdated:' + value)
      this.loadCases()
    },
    confirmStatusUpdated: function (value) {
      console.log('confirmStatusUpdated:' + value)
      if (value === 0) {
        this.filterConfirmStatus = null
      } else {
        this.filterConfirmStatus = (value === 1) ? 'true' : 'false'
      }
      this.loadCases()
    },
    organismById: function (organId) {
      var organName = 'Not Selected'
      if (organId === 0) {
        return organName
      }

      this.organisms.forEach(function (o) {
        if (o.id === organId) {
          organName = o.name
        }
      })

      return organName
    },
    treatmentById: function (treatmentId) {
      var name = 'Not Selected'
      if (treatmentId === 0) {
        return name
      }

      this.treatments.forEach(function (t) {
        if (t.id === treatmentId) {
          name = t.displayText
        }
      })

      return name
    },
    unitById: function (unitId) {
      var unitName = ''
      this.units.forEach(function (u) {
        if (u.id === unitId) {
          unitName = u.displayText
        }
      })

      return unitName
    },
    originById: function (originId) {
      var originName = 'Not Selected'
      this.origins.forEach(function (o) {
        if (o.value === originId && o.value !== 0) {
          originName = o.label
        }
      })
      return originName
    },
    unitByName: function (unitName) {
      var unit = null
      this.units.forEach(function (u) {
        if (u.displayText === unitName) {
          unit = u
        }
      })

      return unit
    },
    precautionById: function (precautionId) {
      var name = ''
      this.precautions.forEach(function (p) {
        if (p.id === precautionId) {
          name = p.displayText
        }
      })

      return name
    },
    photosUrl: function (clientId) {
      if (this.clients[clientId].photo) {
        return '/static/' + this.clients[clientId].photo + '.png'
      }

      return '/static/user.png'
    },
    saveSymtomDetail: function (symptomDetail) {
      var vm = this
      var caseDetail = JSON.parse(JSON.stringify(symptomDetail))
      delete caseDetail.id
      caseDetail.symptoms.forEach(function (s) {
        delete s.id
      })

      if (caseDetail.origin === 0) {
        delete caseDetail.origin
      }

      var jsonData = JSON.stringify(caseDetail)
      this.$http.put(window.CONFIG.api + '/symptomDetails/' + symptomDetail.id, jsonData)
      .then(response => {
        vm.dialogFormVisible = false
        vm.selectedCase = null
        vm.loadCases()
      }, response => {
        // error
        console.log(response)
        this.$message.error('Access Denied')
      })
    },
    reverse: function (array) {
      return array.slice().reverse()
    },
    clientName: function (symptomDetail) {
      var clientData = this.clients[symptomDetail.clientId]
      var firstName = clientData.firstName ? clientData.firstName + ' ' : ''
      var middleName = clientData.middleName ? clientData.middleName + ' ' : ''
      var lastName = clientData.lastName ? clientData.lastName : ''

      return firstName + middleName + lastName
    }
  },
  mounted: function () {
    // this.loadCases()
    // const end = moment().weekday(6).toDate()
    // const start = moment().weekday(0).toDate()
    const lastMonth = moment()
    const end = lastMonth.endOf('month').toDate()
    const start = lastMonth.startOf('month').toDate()
    this.filterDateRange = [start, end]

    this.loadUnits()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.graph {
    overflow-x: scroll;
    position: relative;
    width: 100%;
    height: 450px;
    padding: 1em;
}

.graph > canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 1500px;
  pointer-events:none;
}

.el-card {
    margin-bottom: 1em;
}

.profile-row-photo img {
    width: 3em;
    height: 3em;
    border-radius: 50%;
}

.dialog-case-detail div {
    line-height: 3em;
}

.input-boxes {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}

.clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

.clearfix {
    clear: both;
}

/*.el-button {
  width: 100%;
}*/

.el-tag {
    margin-right: 0.5em;
}

.color-code-label-0 {
    width: 1em;
    height: 1em;
    background: #00D560;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}
.color-code-label-1 {
    width: 1em;
    height: 1em;
    background: #0080FF;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}
.color-code-label-2 {
    width: 1em;
    height: 1em;
    background: #FFDE25;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}

.graph-filter > .el-radio-group {
    padding: 15px;
    float: right;
}
.graph-filter {
    margin-right: 1em;
    margin-left: 3em;
    position: absolute;
    right: 0;
    top: -0.5em;
}

.case-filter > .el-pagination {
  padding-top: 1px;
  float: right;
}
.case-filter > .case-page-size-filte {
  width: 100px;
}
.case-filter > .case-export-button {
  float: left;
  margin-right: 1em;
  margin-top: 1px;
}
.case-filter {
    margin-right: 1em;
    margin-left: 3em;
    position: absolute;
    right: 0;
    top: 0.5em;
}

.filter-title-label {
  margin-left: 2em;
  margin-right: 1em;
  text-align: right;
  line-height: 40px;
}
.filter-section > label {
  display: inline-block;
}
.filter-section {
  margin: 1em;
  padding-bottom: 0.7em;
  display: table-cell;
  vertical-align: middle;
  height: 50px;
  padding-top: 0.5em;
}
.filter-section-input {
  float: right;
}
.symptom-status-image {
  width: 36px;
  position: relative;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.dialog-case-detail div.case-note-date {
  float: right;
  padding: 1em;
  font-size: 1.0em;
  font-weight: 500;
  line-height: 1.8em;
}

.dialog-case-detail div.case-note-content {
  padding: 1em;
  border-bottom: 1px solid #EEEEEE ;
  line-height: 1.8em;
}

.case-note::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px;
}

.case-note::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(0,0,0,.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.case-page-size-filter {
  float: left;
}
</style>



// WEBPACK FOOTER //
// Splash.vue?3680866a